module.exports = __webpack_public_path__ + "static/media/checked.b8c41171.svg";